import { render, staticRenderFns } from "./index.vue?vue&type=template&id=153a4915&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a4915",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153a4915')) {
      api.createRecord('153a4915', component.options)
    } else {
      api.reload('153a4915', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=153a4915&scoped=true", function () {
      api.rerender('153a4915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/tenantManager/index.vue"
export default component.exports